export const hoursEn = {
  buffers: {
    afterClose: 'after close',
    afterOpen: 'after open',
    beforeClose: 'before close',
    beforeOpen: 'before open',
    startAccepting: 'Start accepting orders {minutes} mins {timing}',
    stopAccepting: 'Stop accepting orders {minutes} mins {timing}',
  },
  dayGroups: {
    weekdays: 'Weekdays',
    weekends: 'Weekends',
  },
  days: {
    fri: 'Fri',
    mon: 'Mon',
    sat: 'Sat',
    sun: 'Sun',
    thu: 'Thu',
    tue: 'Tue',
    wed: 'Wed',
  },
  notifications: {
    'special-hours': {
      create: {
        error: 'Unable to create special hours',
        success: 'Special hours created',
      },
      delete: {
        error: 'Unable to delete special hours',
        success: 'Special hours deleted',
      },
      update: {
        error: 'Unable to update special hours',
        success: 'Special hours updated',
      },
    },
  },
  onlineHours: {
    description: 'The hours a guest can place pickup or delivery orders.',
    sameAsStore: 'Same as store hours',
    title: 'Online hours',
  },
  sidebar: {
    specialHours: {
      deleteDialog: {
        action: 'Delete special hours',
        prompt:
          "Are you sure you want to delete special hours for {date}? This can't be undone.",
        title: 'Delete special hours?',
      },
      formView: {
        buttons: {
          cancel: 'Cancel',
          delete: 'Delete',
          save: 'Save',
        },
        dateLabel: 'Date',
        datePlaceholder: 'mm/dd/yyyy',
        hoursLabel: 'Hours',
        repeatLabel: 'Repeat every year',
        title: {
          add: 'Add special hours',
          edit: 'Edit special hours',
        },
      },
      listView: {
        addButton: 'Add special hours',
        subtitle:
          'Dates when your hours of business are different than your regular store hours',
        title: 'Special hours',
      },
    },
    storeHours: {
      formView: {
        cancelButton: 'Cancel',
        closedMessage: 'Store hours are closed on this day.',
        hoursLabel: 'Hours',
        saveButton: 'Save',
      },
      listView: {
        subtitle: 'The hours a guest can come in to the store.',
        title: 'Store hours',
      },
      notifications: {
        error: 'Unable to update store hours',
        success: 'Store hours updated',
      },
    },
  },
  specialHours: {
    closed: 'Closed',
    description:
      'Dates when your hours of business are different than your regular store hours.',
    open24Hours: 'Open 24 hours',
    title: 'Special hours',
  },
  status: {
    closed: 'Closed',
    open24Hours: 'Open 24 hours',
  },
  storeHours: {
    description:
      'The hours a guest can come in to the store and that are viewable on Google',
    title: 'Store hours',
  },
}
